import { call, put, select, takeLatest } from 'redux-saga/effects';
import { salesOrganizationActions as actions } from '.';
import { SalesOrganization } from './types';
import { erpSystemActions } from '../../erpSystem/slice';
import { selectSalesOrganization } from '../../erpSystem/slice/selectors';

export function* fetchSalesOrganization() {
  const { getSalesOrganizationSuccess, getSalesOrganizationFail } = actions;
  const { setErpSystem } = erpSystemActions;
  const sapSalesOrg = yield select(selectSalesOrganization);
  try {
    const salesOrganizationResponse = yield call(
      fetch,
      '/valve-configurator/api/salesOrganisations',
    );
    if (salesOrganizationResponse.status !== 200) {
      return yield put(getSalesOrganizationFail('failed to fetch'));
    } else {
      const salesOrganizations: SalesOrganization[] =
        yield salesOrganizationResponse.json();
      const salesOrganizationOfSap: SalesOrganization | undefined =
        salesOrganizations.find(org => org.sales_organization === sapSalesOrg);
      if (!salesOrganizationOfSap) {
        return yield put(
          getSalesOrganizationFail('no sales organization coming from SAP'),
        );
      }
      yield put(setErpSystem(salesOrganizationOfSap?.country));
      return yield put(getSalesOrganizationSuccess(salesOrganizationOfSap));
    }
  } catch (e) {
    yield put(getSalesOrganizationFail(e));
  }
}

export function* salesOrganizationSaga() {
  yield takeLatest(actions.getSalesOrganization.type, fetchSalesOrganization);
}
